/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Tooltip, IconButton } from '@material-ui/core'

import { QueryBuilder, ArrowRightAlt, ErrorOutline, CheckCircleOutlined, AutorenewTwoTone } from '@material-ui/icons'

const styles = theme => ({
    icon : {
        margin : '2px'
    },
    "@keyframes spin": {
        from: { transform: "rotate(0deg)" },
        to: { transform: "rotate(360deg)" },
    },
    in_progress: {
        color: "#039be5",
        textAlign: "center",
        animation: "$spin 2s infinite linear",
    }
})

class StatusIcon extends Component {
    state = {  }

    renderIcon = () => {
        const { classes } = this.props
        let status = this.props.status
        switch (status) {
            case 'Queued' :
                return (
                    <Tooltip title = {this.props.prefix + " Queued"}>
                        <QueryBuilder fontSize="small" style={{cursor : 'pointer', color: "#FF6600" }} onClick = {(event) => this.props.status_clicked(event)}/>
                    </Tooltip>
                )
            
            case "InProgress" :
                if (this.props.in_progress === 'arrow') {
                    return (
                        <Tooltip title = {this.props.prefix + " In Progress"}>
                            <ArrowRightAlt fontSize="small" style={{cursor : 'pointer', color: "#039be5" }} onClick = {(event) => this.props.status_clicked(event)}/>
                        </Tooltip>
                    )
                } else if (this.props.in_progress === 'refresh_circle') {
                    return (
                        <Tooltip title = {this.props.prefix + " In Progress"}>
                            <AutorenewTwoTone className={classes.in_progress} fontSize="small" style={{cursor : 'pointer', color: "#039be5" }} onClick = {(event) => this.props.status_clicked(event)}/>
                        </Tooltip>
                    )
                }
            
            case "Aborted" :
                return (
                    <Tooltip title = {this.props.prefix + " Aborted"}>
                        <ErrorOutline fontSize="small" style={{cursor : 'pointer', color: "#f44336" }} onClick = {(event) => this.props.status_clicked(event)}/>
                    </Tooltip>
                )
            
            case "Completed" :
                return (
                    <Tooltip title = {this.props.prefix + " Completed"}>
                        <CheckCircleOutlined fontSize="small" style={{cursor : 'pointer', color: "#4caf50" }} onClick = {(event) => this.props.status_clicked(event)}/>
                    </Tooltip>
                )
            
            case "Ready" :
                return (
                    <Tooltip title = {this.props.prefix + " Completed"}>
                        <CheckCircleOutlined fontSize="small" style={{cursor : 'pointer', color: "#4caf50" }} onClick = {(event) => this.props.status_clicked(event)}/>
                    </Tooltip>
                )
            default :
                return null
        }
    }

    renderStatusIcon = () => {
        if (this.props.status) {
            return (
                <IconButton style = {{ ...this.props.style}} size = 'small'>
                    {this.renderIcon()}
                </IconButton>
            )
        } else {
            return null
        }
    }

    render() { 
        return (
            this.renderStatusIcon()
        );
    }
}
 
export default withStyles(styles)(StatusIcon);